////////////*Feature:Multiple Choice/Single Choice Questions///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function resetQuiz() {
  var choices = $("#" + globalVar.curSlide + " .si-quiz__js li");
  choices.removeClass("si-quiz-selected")
}
function initQuiz(){
    var quizzes = $(".si-quiz__js");
    var buttonType = globalVar.buttonType;
    quizzes.each(function(idx, quiz){
        var choices = $(quiz).find("li");
        var buttons = $(quiz).find("div");
        var isRadio = $(quiz).hasClass('si-radio__js') ? true : false;
        choices.each(function (idx, choice) {
          $(choice).addClass("si-quiz-answer").attr("tabindex", "0");
          $(choice).on("click.quiz", function () {
            siAudio.sfx.click.play()
            if (isRadio) {
              choices.removeClass("si-quiz-selected");
            }
            if ($(this).hasClass("si-quiz-selected")) {
              $(this).removeClass("si-quiz-selected");
            } else {
              $(this).addClass("si-quiz-selected");
            }
          });
          $(choice).on("keyup.quiz", function () {
            if (event.which === 13) {
                siAudio.sfx.click.play()
                if (isRadio) {
                  choices.removeClass("si-quiz-selected");
                }
                if ($(this).hasClass("si-quiz-selected")) {
                  $(this).removeClass("si-quiz-selected");
                } else {
                  $(this).addClass("si-quiz-selected");
                }
            }
          });
        });
        buttons.each(function (idx, button) {
            var image = $(button).children().eq(0);
            if (isRadio) {
                $(image).attr("src", function (index, attr) {
                    return attr.replace("mcq", "scq");
                });
            }else{
                $(image).attr("src", function (index, attr) {
                return attr.replace("scq", "mcq");
                });
            }
            
            $(button).find("img").attr("src", function (index, attr) {
              return attr.replace("classic", buttonType);
            });
        });
    })
}
function quizFunction(){
    var answers = slides[globalVar.curSlide]["quiz"]["answers"];
    var choices = $("#" + globalVar.curSlide + " .si-quiz__js li");
    if (!slides[globalVar.curSlide]["visited"] && globalVar.devMode) {
      choices.each(function (idx, choice) {
        if (answers[$(choice).attr("id")]) {
            $(choice).css("color", "blue");
        }
      });
    }else{
        resetQuiz()
    }
}